import { render, staticRenderFns } from "./BInputNumber.vue?vue&type=template&id=09003d64&scoped=true"
import script from "./BInputNumber.vue?vue&type=script&lang=js"
export * from "./BInputNumber.vue?vue&type=script&lang=js"
import style0 from "./BInputNumber.vue?vue&type=style&index=0&id=09003d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09003d64",
  null
  
)

export default component.exports